// extracted by mini-css-extract-plugin
export default {"PercentageBarVisualization":"PercentageBarVisualization_PercentageBarVisualization__AuyaQ","container":"PercentageBarVisualization_container__e6xr9"};